import { render, staticRenderFns } from "./security-code.vue?vue&type=template&id=637f12d5"
import script from "./security-code.vue?vue&type=script&lang=js"
export * from "./security-code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports